import React from 'react';
import { StyledMenuItemButton, StyledIconWrapper, StyledContentWrapper } from './DropdownMenuItem.styles'; // 스타일 컴포넌트 임포트
/**
 * DropdownMenuItem - 드롭다운 메뉴의 항목 컴포넌트
 * 
 * 드롭다운 메뉴 내부의 각 항목을 표시합니다.
 * 여러 종류의 변형(variant)과 아이콘을 추가할 수 있습니다.
 */ var DropdownMenuItem = function(param) {
    var onClick = param.onClick, children = param.children, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, icon = param.icon, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_$currencyItem = param.$currencyItem, $currencyItem = _param_$currencyItem === void 0 ? false : _param_$currencyItem;
    var handleClick = function(event) {
        if (!disabled) {
            onClick(event);
        // 메뉴 닫는 로직은 DropdownMenu에서 처리
        }
    };
    return /*#__PURE__*/ React.createElement(StyledMenuItemButton, {
        variant: variant,
        disabled: disabled,
        className: className,
        onClick: handleClick,
        type: "button" // 버튼 타입 명시
        ,
        $currencyItem: $currencyItem
    }, icon && /*#__PURE__*/ React.createElement(StyledIconWrapper, null, icon), /*#__PURE__*/ React.createElement(StyledContentWrapper, null, children));
};
export default DropdownMenuItem;
